import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(value?: string): string {
    if (!value) return '';

    // Split the time string into components
    const [hours, minutes, seconds] = value.split(':').map(Number);

    // Determine AM or PM suffix
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM

    // Format the result as "hh:mm AM/PM"
    return `${this.padNumber(adjustedHours)}:${this.padNumber(minutes)} ${period}`;
  }

  private padNumber(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }

}
